import React from 'react'
import styled from 'styled-components'

import headerBg from '../assets/header-bg.jpg'
const Header = styled.div.attrs({ className: 'container-fluid shadow-sm'})`
  background: #82d0e0 url(${headerBg}) no-repeat;
  background-position: center 0;
  background-size: contain;
`

// const Stripe = styled.div`
//   position: absolute;
//   top:0;
//   left: 0;
//   width: 100%;
//   height: 50px;
//   background: white;
// `
export default ({children}) => <Header>
  {children}
</Header>



// WEBPACK FOOTER //
// ./src/components/header.js